import competitionRoutes from "./competitionRoutes";
import mediiiaLegalRoutes from "./mediiiaLegalRoutes";
import projectRoutes from "./projectRoutes";
import bookRoutes from "./bookRoutes";
import teamRoutes from "./teamRoutes";
import tagRoutes from "./tagRoutes";
import LMSRoutes from "./LMSRoutes";
import paymentRoutes from "./paymentRoutes";
import designerRoutes from "./designerRoutes";
import deprecatedRoutes from "./deprecatedRoutes";
import contextRoutes from "./contextRoutes";
import adminRoutes from "./adminRoutes";
import magistracyRoutes from "./magistracyRoutes";

const commonRoutes = (config?: any) => [
    ...adminRoutes,
    ...contextRoutes,
    ...deprecatedRoutes,
    ...magistracyRoutes,
    ...designerRoutes,
    ...tagRoutes,
    ...bookRoutes,
    ...LMSRoutes,
    ...projectRoutes,
    ...competitionRoutes,
    ...mediiiaLegalRoutes,
    ...teamRoutes,
    ...paymentRoutes,
    
]

export default commonRoutes;import competitionRoutes from "./competitionRoutes";
import mediiiaLegalRoutes from "./mediiiaLegalRoutes";
import projectRoutes from "./projectRoutes";
import bookRoutes from "./bookRoutes";
import teamRoutes from "./teamRoutes";
import tagRoutes from "./tagRoutes";
import LMSRoutes from "./LMSRoutes";
import paymentRoutes from "./paymentRoutes";
import designerRoutes from "./designerRoutes";
import deprecatedRoutes from "./deprecatedRoutes";
import contextRoutes from "./contextRoutes";
import adminRoutes from "./adminRoutes";
import magistracyRoutes from "./magistracyRoutes";

const commonRoutes = (config?: any) => [
    ...adminRoutes,
    ...contextRoutes,
    ...deprecatedRoutes,
    ...magistracyRoutes,
    ...designerRoutes,
    ...tagRoutes,
    ...bookRoutes,
    ...LMSRoutes,
    ...projectRoutes,
    ...competitionRoutes,
    ...mediiiaLegalRoutes,
    ...teamRoutes,
    ...paymentRoutes,
    
]

export default commonRoutes;